"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEffectiveVersionBounds = resolveEffectiveVersionBounds;
/**
 * Resolves an activation's effective version bounds against its event's
 * defaults. Each bound is overridden independently: an activation that sets
 * its own minimumVersion but not maximumVersion still inherits the event's
 * maximumVersion default, and vice versa.
 *
 * Shared between the events service (server-side feed filtering) and the CMS
 * client (author-time preview) so the two can never drift apart.
 */
function resolveEffectiveVersionBounds(event, activation) {
    return {
        minimumVersion: activation?.minimumVersion ?? event.minimumVersion ?? null,
        maximumVersion: activation?.maximumVersion ?? event.maximumVersion ?? null,
    };
}
